import { gql, useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import {
  ISetUserDepositRequest,
  ISetUserDepositResponse,
  SET_USER_DEPOSIT,
} from 'schemas';
import notification from 'services/notificationService';

import { TSetDeposit } from './interfaces';

export const useSetDeposit = (t: TTranslator<TLocalesKeys>): TSetDeposit => {
  const [setDeposit] = useMutation<
    ISetUserDepositResponse,
    ISetUserDepositRequest
  >(SET_USER_DEPOSIT, {
    update: (cache, { data }) => {
      const user = data?.setDeposit;

      if (!user) return;

      cache.writeFragment({
        id: cache.identify(user),
        data: user,
        fragment: gql`
          fragment deposit on User {
            deposit
          }
        `,
      });
    },
    onCompleted: () => {
      notification.info({
        t,
        title: t('clients.depositChanged'),
        type: 'success',
        dismiss: 5,
      });
    },
  });

  return setDeposit;
};
